
const ConvertDecimalPlaces = (val) => {
    let data = Number(val);
    let result = Number.isInteger(data) ? data : (Number.isInteger(data * 10) ? data.toFixed(1) : Number.isInteger(data * 100) ? data.toFixed(2) :data.toFixed(3));
    return Number(result);
}

export default ConvertDecimalPlaces
